import { FC } from 'react';
import classNames from 'classnames';
import { HeaderInfo, HeaderPrice } from '#advertDetail/components';
import advertDetailCss from '../../assets/advert-detail.module.scss';
import advertDetailHeaderCss from '../../assets/header/header.module.scss';

const Header: FC = () => (
  <div className={classNames(advertDetailCss.advertDetail__header, advertDetailHeaderCss.advertDetailHeader)}>
    <HeaderInfo />
    <HeaderPrice />
  </div>
);

export { Header };
